<template lang="pug">
  router-link.p-4.rounded-lg.bg-gray-0.flex.my-2.items-center.active(class="hover:bg-white hover:shadow-lg" :to="'/key-result?kr=' + keyResult.id")
    .flex.flex-grow.items-center(class="sm:flex-col")
      h2.text-gray-8.font-normal.pr-2 {{keyResult.title}}

      .flex-grow(class="sm:w-full sm:mt-2")
        p.text-xs.text-gray-6.mb-1 {{keyResult.initialValue}} of {{keyResult.targetValue}} {{keyResult.unit}}
        .rounded-lg.h-2.w-full.bg-gray-3
          .rounded-lg.h-full.bg-blue-5(:style="{width: getPercent, background: color}")

    eva-icon.icon.text-gray-5.ml-8(name="chevron-right")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Resizable from "./Resizable";
import DoughnutChart from "vue-doughnut-chart";

export default {
  props: ["keyResult", "index"],
  components: { Resizable, DoughnutChart },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters(["company", "profile"]),
    getPercent() {
      if (this.keyResult.initialValue == 0) return "0%";
      else
        return (
          Math.round(
            (this.keyResult.initialValue / this.keyResult.targetValue) * 100
          ) + "%"
        );
    },
    color() {
      switch (this.keyResult.status) {
        case "On track":
          return "#228be6";
        case "At risk":
          return "#fd7e14";
        case "Off track":
          return "#fa5252";
        default:
          return "#fff";
      }
    }
  },
  methods: {
    ...mapActions(["blur", "select"])
  }
};
</script>

<style lang="sass" scoped>
h2
  width: 70%
@media only screen and (max-width: 639px)
  h2
    width: 100%
</style>
